/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../../../../Fixes';
import Builder from '../../../../../../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "devicesettings": {
        "nested": {
          "profiles": {
            "nested": {
              "v2": {
                "nested": {
                  "model": {
                    "nested": {
                      "settings": {
                        "nested": {
                          "rtl": {
                            "nested": {
                              "ItemDetails": {
                                "fields": {
                                  "variationSelectionMethod": {
                                    "type": ".squareup.devicesettings.profiles.v2.model.settings.rtl.ItemDetails.VariationSelectionMethod",
                                    "id": 1,
                                    "rule": "optional",
                                    "options": {
                                      "default": "DRILL_IN"
                                    }
                                  }
                                },
                                "nested": {
                                  "VariationSelectionMethod": {
                                    "values": {
                                      "CHOICE_BUTTONS": 0,
                                      "DRILL_IN": 1
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rtl?.nested?.ItemDetails && !$root.nested?.squareup?.nested?.devicesettings?.nested?.profiles?.nested?.v2?.nested?.model?.nested?.settings?.nested?.rtl?.nested?.ItemDetails?.nested?.VariationSelectionMethod) {
  $root.addJSON(jsonData);
}

/**
 * IMPORTANT: When Adding New Fields to Device Profiles, you MUST implement their default values at:
 *
 * /java/device-settings/src/main/java/com/squareup/devicesettings/processing/profiles/v2/defaults
 *
 * ⚠️ WARNING: Fields will not be automatically hydrated unless default values are implemented in the Java code above.
 * This is a mandatory step for all device profile settings.
 *
 * SOURCE ItemDetails @ squareup/devicesettings/profiles/v2/model/settings/rtl/item_details.proto at 17:1
 */
export const ItemDetails = $root.lookupType('squareup.devicesettings.profiles.v2.model.settings.rtl.ItemDetails');
fixType(ItemDetails);
Builder.createAndAttachToType(ItemDetails);
/**
 * SOURCE VariationSelectionMethod @ squareup/devicesettings/profiles/v2/model/settings/rtl/item_details.proto at 18:3
 */
ItemDetails.VariationSelectionMethod = $root.lookupEnum('squareup.devicesettings.profiles.v2.model.settings.rtl.ItemDetails.VariationSelectionMethod').values;